import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import axios from 'axios';
import { toast } from 'react-toastify';
import { Mixpanel } from '../../../common/utils/mixpanelUtil';
import {
  COLLECTIONS_EXTRACT_COLLECTION_DATA_BEGIN,
  COLLECTIONS_EXTRACT_COLLECTION_DATA_SUCCESS,
  COLLECTIONS_EXTRACT_COLLECTION_DATA_FAILURE,
  COLLECTIONS_EXTRACT_COLLECTION_DATA_DISMISS_ERROR,
} from './constants';

export function extractCollectionData(args = {}) {
  return (dispatch) => {
    dispatch({
      type: COLLECTIONS_EXTRACT_COLLECTION_DATA_BEGIN,
    });
    const { projectId, version } = args;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_AI_ENGINE}v${version}/generate-fields-data`,
        args,
        header,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: COLLECTIONS_EXTRACT_COLLECTION_DATA_SUCCESS,
            data: res.data,
          });
          Mixpanel.track('Created data', {
            uuid: res.data.uuid,
            collectionName: res.data.collectionName,
          });
          resolve(res);
        },
        (err) => {
          toast.error(`Failed: ${err.response.data.error}`, {});
          Mixpanel.track('Failed to extract data');
          dispatch({
            type: COLLECTIONS_EXTRACT_COLLECTION_DATA_FAILURE,
            data: { error: `Failed` },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissExtractCollectionDataError() {
  return {
    type: COLLECTIONS_EXTRACT_COLLECTION_DATA_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COLLECTIONS_EXTRACT_COLLECTION_DATA_BEGIN:
      return {
        ...state,
        extractCollectionDataPending: true,
        extractCollectionDataError: null,
      };

    case COLLECTIONS_EXTRACT_COLLECTION_DATA_SUCCESS:
      return {
        ...state,
        extractCollectionDataPending: false,
        extractCollectionDataError: null,
      };

    case COLLECTIONS_EXTRACT_COLLECTION_DATA_FAILURE:
      return {
        ...state,
        extractCollectionDataPending: false,
        extractCollectionDataError: action.data.error,
      };

    case COLLECTIONS_EXTRACT_COLLECTION_DATA_DISMISS_ERROR:
      return {
        ...state,
        extractCollectionDataError: null,
      };

    default:
      return state;
  }
}
